import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { L10nTranslationService, L10N_LOCALE, L10nLocale } from 'angular-l10n';
import { Inject, Injectable } from '@angular/core';

export const SB_PANEL_MESSAGE = 'snackbar-status-message';
export const SB_PANEL_ERROR = 'snackbar-error-message';
export const SB_PANEL_WARN = 'snackbar-warn-message';
export const SB_DEFAULT_DURATION = 5000;

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  constructor(
    @Inject(L10N_LOCALE) private readonly locale: L10nLocale,
    private readonly translation: L10nTranslationService,
    private readonly sb: MatSnackBar
  ) { }

  static errorConfig(duration: number = SB_DEFAULT_DURATION): MatSnackBarConfig {
    return { duration: duration, panelClass: SB_PANEL_ERROR, politeness: 'assertive', verticalPosition: 'top', };
  }

  static warnConfig(duration: number = SB_DEFAULT_DURATION): MatSnackBarConfig {
    return { duration: duration, panelClass: SB_PANEL_WARN, politeness: 'assertive', verticalPosition: 'top', };
  }

  static infoConfig(duration: number = SB_DEFAULT_DURATION): MatSnackBarConfig {
    return { duration: duration, panelClass: SB_PANEL_MESSAGE, politeness: 'assertive', verticalPosition: 'top', };
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error(message: string, action: string = 'OK', params: any = null, config: MatSnackBarConfig = null) {
    const merged = Object.assign(SnackbarService.errorConfig(), config);
    this.open(message, action, params, merged);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  warn(message: string, action: string = 'OK', params: any = null, config: MatSnackBarConfig = null) {
    const merged = Object.assign(SnackbarService.warnConfig(), config);
    this.open(message, action, params, merged);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  info(message: string, action: string = 'OK', params: any = null, config: MatSnackBarConfig = null) {
    const merged = Object.assign(SnackbarService.infoConfig(), config);
    this.open(message, action, params, merged);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  open(message: string, action?: string, params?: any, config?: MatSnackBarConfig): void {
    if (action) {
      action = this.translation.translate(action, null, this.locale.language);
    }

    this.sb.open(
      this.translation.translate(message, params, this.locale.language),
      action,
      {
        // default duration, can be overriden by config
        duration: SB_DEFAULT_DURATION,
        ...config,
      }
    );
  }
}
